const errorKinds = {
  VERIFICATION_TOKEN_EXPIRED: "expired",
  VERIFICATION_TOKEN_CONSUMED: "consumed",
  VERIFICATION_TOKEN_UNKNOWN: "unknown",
  VERIFICATION_PASSWORD_REQUIRED: "password-required",
  VERIFICATION_PASSWORD_ALREADY_SET: "password-already-set",
};

export function mapVerificationOutcome(response) {
  if (
    response?.status === 200
    && response.data?.is_verified === true
    && typeof response.data?.already_verified === "boolean"
  ) {
    return {
      kind: response.data.already_verified ? "already-verified" : "success",
      authenticated: response.data.authenticated === true,
      first_name: response.data.first_name ?? null,
    };
  }

  const errorKind = errorKinds[response?.data?.detail?.error_code];
  if (response?.status === 400 && errorKind) {
    return {kind: errorKind};
  }

  const retryAfterSeconds = response?.data?.detail?.retry_after_seconds;
  if (response?.status === 429 && Number.isFinite(retryAfterSeconds)) {
    return {kind: "rate-limited", retryAfterSeconds};
  }

  return {kind: "unconfirmed"};
}
